var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.70064 9.78008L2.59293 10L2.70064 10.2199C3.41533 11.6792 4.5251 12.9087 5.90379 13.7686C7.28249 14.6286 8.87478 15.0844 10.4997 15.0844C12.1246 15.0844 13.7169 14.6286 15.0956 13.7686C16.4742 12.9087 17.584 11.6792 18.2987 10.2199L18.4064 10L18.2987 9.78008C17.584 8.3208 16.4742 7.09131 15.0956 6.23138C13.7169 5.37145 12.1246 4.91557 10.4997 4.91557C8.87478 4.91557 7.28249 5.37145 5.90379 6.23138C4.5251 7.09131 3.41533 8.3208 2.70064 9.78008ZM10.4997 8C11.0301 8 11.5388 8.21071 11.9139 8.58579C12.289 8.96086 12.4997 9.46957 12.4997 10C12.4997 10.5304 12.289 11.0391 11.9139 11.4142C11.5388 11.7893 11.0301 12 10.4997 12C9.96924 12 9.46053 11.7893 9.08546 11.4142C8.71039 11.0391 8.49967 10.5304 8.49967 10C8.49967 9.46957 8.71039 8.96086 9.08546 8.58579C9.46053 8.21071 9.96924 8 10.4997 8ZM10.4997 4.25C14.3834 4.25 17.7123 6.62268 19.1267 10C17.7123 13.3773 14.3834 15.75 10.4997 15.75C6.61593 15.75 3.28704 13.3773 1.87269 10C3.28704 6.62269 6.61593 4.25 10.4997 4.25Z",
    fill: "#4CAF50",
    stroke: "#4CAF50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.036b66e9c3efe6e51f5c858bf0b50559.svg";
export { ForwardRef as ReactComponent };